export default "__VITE_ASSET__LxkOKUtO__"